import {
  Ref,
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import VideoPlayer from 'modules/trainings/components/VideoPlayer'
import {
  contentContainer,
  titleStyle,
  videoContainer,
} from 'modules/trainings/components/content/styles.vanilla.css'
import {
  ContentConsumerCallbacks,
  ContentConsumerProps,
} from 'modules/trainings/components/content/types'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

const VIDEO_COMPLETION_THRESHOLD = 98

export const VideoBlockConsumer = forwardRef(function VideoBlockConsumer(
  { contentItem, updateNextButton }: ContentConsumerProps<VideoBlock>,
  ref: Ref<ContentConsumerCallbacks>
) {
  const isAlreadyCompleted = contentItem.status === 'completed'
  const [hasWatchedEnough, setHasWatchedEnough] = useState(isAlreadyCompleted)
  const isFirstRender = useRef(true)

  const handleMilestone = useCallback((milestone: number) => {
    if (milestone >= VIDEO_COMPLETION_THRESHOLD) {
      setHasWatchedEnough(true)
    }
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    updateNextButton()
  }, [hasWatchedEnough, updateNextButton])

  useImperativeHandle(
    ref,
    () => ({
      handleNext: async () => true,
      nextEnabled: () => hasWatchedEnough,
      nextLabel: () => '',
    }),
    [hasWatchedEnough]
  )

  return (
    <Box width="full" alignItems="center" gap="s24" style={{ marginBottom: '-20px' }}>
      <Box width="full" className={contentContainer} gap="s24">
        <F0Text content={contentItem.title} variant="body" style={titleStyle} />
      </Box>

      {contentItem.video.url && (
        <Box width="full" className={videoContainer}>
          <VideoPlayer
            src={contentItem.video.url}
            onPercentageWatchedMilestone={handleMilestone}
            disableAdvancedControls
          />
        </Box>
      )}
    </Box>
  )
})
